export const WHATSAPP_NUMMER = "4917696084998";

export function whatsappLink(text) {
  const nachricht = text || "Hallo, ich möchte mein Auto verkaufen.";
  return `https://wa.me/${WHATSAPP_NUMMER}?text=${encodeURIComponent(nachricht)}`;
}
